/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:43
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2022-05-23 00:10:14
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\main.js
 */
import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import store from './store'
import router from './router' //导入router\index.js下的 路由对象，在'#app' 里面$mount
import './directives'
import '@/common'
import global_ from './components/Global' //引用文件
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable)
Vue.prototype.GLOBAL = global_ //全局变量 挂载到Vue实例上面  彭妙培
Vue.config.productionTip = false
//创建和挂载根实例。
Vue.prototype.$bus = new Vue()
new Vue({
  el: '#app',
  i18n,
  store,
  // 记得要通过 router 配置参数注入路由，
  // 从而让整个应用都有路由功能
  router,
  render: (h) => h(App),
})
